<h1 mat-dialog-title>Bestätigung</h1>
<div mat-dialog-content>
  {{message}}
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">Nein</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Ja</button>
</div>
